import { useState, useEffect, useCallback } from 'react';
import { Tabs, Row, Col, FormInstance } from 'antd';
import StudentConfig from "@/config/student";
import { convertToTimestamp, startTimeToday, endTimeToday } from "@/lib/dateTime";
import { ClassType, StudentType } from './types';
import Students from './Students';
import StudentsRollCall from './StudentsRollCall';

const { getAllStudentByClass } = StudentConfig;
const { TabPane } = Tabs;

type Props = {
  classArray: ClassType[];
  isRollCall: boolean;
  yearSemesterForm: FormInstance;
}

function Classes(props: Props) {
  const { classArray, isRollCall, yearSemesterForm } = props;
  const [selectedClassId, setSelectedClassId] = useState<string>('');
  const [studentArray, setStudentArray] = useState<StudentType[]>([]);

  const getAllStudentByClassFunction = useCallback(() => {
    const params = {
      classId: selectedClassId,
      startTime: convertToTimestamp(startTimeToday),
      endTime: convertToTimestamp(endTimeToday),
    };
    getAllStudentByClass(params).then((res: any) => {
      const studentArray = res?.value ?? [];
      setStudentArray(studentArray);
    });
  }, [selectedClassId]);

  useEffect(() => {
    setSelectedClassId(`${classArray[0]?.classId ?? ''}`);
  }, [classArray]);

  useEffect(() => {
    selectedClassId && getAllStudentByClassFunction();
  }, [getAllStudentByClassFunction, selectedClassId]);

  function renderClassTab() {
    return classArray.map((item: ClassType) => {
      const { classId, className } = item;

      return (
        <TabPane key={classId} tab={className}>
          {isRollCall
            ? <StudentsRollCall studentArray={studentArray} />
            : <Students
              studentArray={studentArray}
              classId={classId}
              getAllStudentByClassFunction={getAllStudentByClassFunction}
              yearSemesterForm={yearSemesterForm}
            />
          }
        </TabPane >
      );
    });
  };

  return (
    <Row>
      <Col span={24}>
        <Tabs
          size="large"
          tabPosition="left"
          onChange={setSelectedClassId}
          activeKey={selectedClassId}
          destroyInactiveTabPane
        >
          {renderClassTab()}
        </Tabs>
      </Col>
    </Row>
  )
}

export default Classes;